import { cva, VariantProps } from 'class-variance-authority';
import { FC, ReactNode } from 'react';

import { cn } from '../../libs/utils';

const tableCellVariant = cva('', {
  variants: {
    variant: {
      header: 'w-full max-w-[132px] text-neutral-foreground-low',
      content: 'font-medium text-neutral-foreground-main'
    },
    size: {
      medium: 'py-normal-medium body-large-regular',
      small: 'py-normal-small body-small-regular',
      xsmall: 'py-tiny-large caption-small-regular'
    }
  },
  defaultVariants: {
    variant: 'content'
  }
});

interface TableCellProps extends VariantProps<typeof tableCellVariant> {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  size?: 'medium' | 'small' | 'xsmall';
}

export const TableCell: FC<TableCellProps> = ({ children, className, size = 'medium', variant = 'content', onClick, style = {}, ...props }) => {
  return (
    <div className={cn(tableCellVariant({ variant, size }), className)} role={'cell'} style={style} onClick={onClick} {...props}>
      {children}
    </div>
  );
};
